import { Color } from "@bonliva-crm/ui";
import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles({
  padding20: {
    padding: 20
  },
  displayInline: {
    display: "inline"
  },
  flexCenter: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "4px"
  },
  flexLeft: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "4px"
  },
  listWrapper: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "16px"
  },
  borderRadius2: {
    borderRadius: "2px"
  },
  pointer: {
    cursor: "pointer"
  },
  flexCenterColumn: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column"
  },
  fileUploadWrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start"
  },
  topWrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "100%",
    gap: "16px"
  },
  fileListWrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    minHeight: "50rem"
  },
  documentTypeItem: {
    "&:hover": {
      backgroundColor: "rgba(255, 134, 123, 0.15)"
    }
  },
  buttonWrapper: {
    display: "flex",
    flexDirection: "row",
    marginTop: "1rem",
    gap: "1rem",
    justifyContent: "flex-end"
  },
  width100: {
    width: "100%"
  },
  width75: {
    width: "75%"
  },
  fileListItem: {
    borderBottom: `1px solid ${Color.LightGray}`,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px 0"
  },
  itemWrapper: {
    boxShadow: "1px 6px 24px 0px rgba(128, 128, 128, 0.15)",
    borderRadius: "2px",
    border: `1px solid ${Color.LightGray}`
  },
  textEllipsis: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  fileListTextWrapper: {
    display: "flex",
    alignItems: "center",
    overflow: "hidden"
  },
  documentTypeWrapper: {
    marginTop: "1rem"
  }
});
